(function () {
  'use strict';

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.from((root || document).querySelectorAll(selector));
  }

  /*
  ============================================================
  LIGHT / DARK MODE
  ============================================================
  */

  function applyCometTheme(theme) {
    var isDark = theme === 'dark';

    document.body.classList.toggle('theme-dark', isDark);
    document.documentElement.style.colorScheme = isDark ? 'dark' : 'light';

    qsa('[data-comet-theme-toggle]').forEach(function (button) {
      button.setAttribute('aria-checked', String(isDark));
      button.setAttribute(
        'aria-label',
        isDark ? 'Switch to normal mode' : 'Switch to dark mode'
      );

      var thumb = qs('.thumb', button);

      if (thumb) {
        thumb.textContent = isDark ? '☾' : '☀';
      }
    });

    qsa('[data-comet-theme-label]').forEach(function (label) {
      label.textContent = isDark ? 'Dark' : 'Normal';
    });
  }

  function loadSavedTheme() {
    var savedTheme = 'light';

    try {
      savedTheme = localStorage.getItem('comet-theme') || 'light';
    } catch (error) {}

    applyCometTheme(savedTheme);
  }

  /*
  ============================================================
  MOBILE NAVIGATION
  ============================================================
  */

  function closeMobileNavigation() {
    var mobileNav = qs('[data-comet-mobile-nav]');
    var menuButton = qs('[data-comet-menu-toggle]');

    if (mobileNav) {
      mobileNav.style.display = 'none';
    }

    if (menuButton) {
      menuButton.textContent = '☰';
    }
  }

  /*
  ============================================================
  SERVICE ACCORDIONS
  ============================================================
  */

  function initServiceAccordions(root) {
    qsa('[data-comet-service-button]', root).forEach(function (button) {
      if (button.dataset.cometBound === 'true') {
        return;
      }

      button.dataset.cometBound = 'true';

      button.addEventListener('click', function () {
        var service = button.closest('.service');
        var list = button.closest('.service-list');

        if (!service || !list) {
          return;
        }

        var alreadyOpen = service.classList.contains('open');

        qsa('.service', list).forEach(function (item) {
          item.classList.remove('open');

          var itemButton = qs('[data-comet-service-button]', item);

          if (itemButton) {
            itemButton.setAttribute('aria-expanded', 'false');
          }
        });

        if (!alreadyOpen) {
          service.classList.add('open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /*
  ============================================================
  UAE / SAUDI / EUROPE → GCC MARKET TABS
  ============================================================
  */

  function initMarketTabs(root) {
    qsa('[data-market]', root).forEach(function (button) {
      if (button.dataset.cometBound === 'true') {
        return;
      }

      button.dataset.cometBound = 'true';

      button.addEventListener('click', function () {
        var marketSection = button.closest('.region');

        if (!marketSection) {
          return;
        }

        qsa('[data-market]', marketSection).forEach(function (tab) {
          tab.classList.remove('active');
          tab.setAttribute('aria-selected', 'false');
        });

        button.classList.add('active');
        button.setAttribute('aria-selected', 'true');

        var marketKey = button.dataset.market;

        var dataElement = qs(
          '[data-market-json="' + marketKey + '"]',
          marketSection
        );

        if (!dataElement) {
          return;
        }

        var marketData;

        try {
          marketData = JSON.parse(dataElement.textContent);
        } catch (error) {
          console.warn('Comet market data could not be loaded.', error);
          return;
        }

        var marketLabel = qs('#marketLabel', marketSection);
        var cityCode = qs('#cityCode', marketSection);
        var marketTitle = qs('#marketTitle', marketSection);
        var marketCopy = qs('#marketCopy', marketSection);

        if (marketLabel) {
          marketLabel.textContent = marketData.label;
        }

        if (cityCode) {
          cityCode.textContent = marketData.code;
        }

        if (marketTitle) {
          marketTitle.textContent = marketData.title;
        }

        if (marketCopy) {
          marketCopy.textContent = marketData.copy;
        }

        if (marketData.notes) {
          [1, 2, 3].forEach(function (number, index) {
            var heading = qs(
              '#note' + number + 'h',
              marketSection
            );

            var text = qs(
              '#note' + number,
              marketSection
            );

            if (marketData.notes[index]) {
              if (heading) {
                heading.textContent = marketData.notes[index][0];
              }

              if (text) {
                text.textContent = marketData.notes[index][1];
              }
            }
          });
        }
      });
    });
  }

  /*
  ============================================================
  SELECTED WORK / PROJECT CAROUSEL
  ============================================================
  */

  function initWorkRails(root) {
    qsa('[data-comet-work]', root).forEach(function (section) {
      if (section.dataset.cometWorkBound === 'true') {
        return;
      }

      section.dataset.cometWorkBound = 'true';

      var rail = qs('.work-rail-v10', section);
      var previousButton = qs('[data-work-prev]', section);
      var nextButton = qs('[data-work-next]', section);
      var counter = qs('[data-work-counter]', section);

      if (!rail || !counter) {
        return;
      }

      function getCards() {
        return qsa('.work-card-v10', rail);
      }

      function getCurrentIndex() {
        var cards = getCards();

        if (!cards.length) {
          return 0;
        }

        var railLeft = rail.getBoundingClientRect().left;

        var closestIndex = 0;
        var closestDistance = Infinity;

        cards.forEach(function (card, index) {
          var distance = Math.abs(
            card.getBoundingClientRect().left - railLeft
          );

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function updateCounter() {
        var cards = getCards();
        var total = cards.length;

        if (!total) {
          counter.textContent = '00 / 00';
          return;
        }

        var current = getCurrentIndex() + 1;

        counter.textContent =
          String(current).padStart(2, '0') +
          ' / ' +
          String(total).padStart(2, '0');
      }

      function moveRail(direction) {
        var cards = getCards();

        if (!cards.length) {
          return;
        }

        var currentIndex = getCurrentIndex();

        var targetIndex = Math.max(
          0,
          Math.min(
            cards.length - 1,
            currentIndex + direction
          )
        );

        cards[targetIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }

      if (previousButton) {
        previousButton.addEventListener('click', function () {
          moveRail(-1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          moveRail(1);
        });
      }

      rail.addEventListener(
        'scroll',
        function () {
          window.clearTimeout(rail._cometScrollTimer);

          rail._cometScrollTimer = window.setTimeout(
            updateCounter,
            80
          );
        },
        { passive: true }
      );

      window.addEventListener('resize', updateCounter);

      updateCounter();
    });
  }

  /*
  ============================================================
  CONTACT MODAL
  ============================================================
  */

  function openContactModal() {
    var modal = qs('#contactModal');

    if (!modal) {
      return;
    }

    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeContactModal() {
    var modal = qs('#contactModal');

    if (!modal) {
      return;
    }

    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  /*
  ============================================================
  GLOBAL CLICK EVENTS
  ============================================================
  */

  function initGlobalClickEvents() {
    if (document.documentElement.dataset.cometGlobalBound === 'true') {
      return;
    }

    document.documentElement.dataset.cometGlobalBound = 'true';

    document.addEventListener('click', function (event) {
      /*
      DARK MODE SWITCH
      */

      var themeButton = event.target.closest(
        '[data-comet-theme-toggle]'
      );

      if (themeButton) {
        var nextTheme = document.body.classList.contains(
          'theme-dark'
        )
          ? 'light'
          : 'dark';

        try {
          localStorage.setItem(
            'comet-theme',
            nextTheme
          );
        } catch (error) {}

        applyCometTheme(nextTheme);

        return;
      }

      /*
      MOBILE MENU
      */

      var menuButton = event.target.closest(
        '[data-comet-menu-toggle]'
      );

      if (menuButton) {
        var mobileNav = qs(
          '[data-comet-mobile-nav]'
        );

        if (!mobileNav) {
          return;
        }

        var isOpen =
          mobileNav.style.display === 'block';

        mobileNav.style.display =
          isOpen ? 'none' : 'block';

        menuButton.textContent =
          isOpen ? '☰' : '×';

        return;
      }

      /*
      CLOSE MOBILE MENU AFTER LINK CLICK
      */

      var mobileNavLink = event.target.closest(
        '[data-comet-mobile-nav] a'
      );

      if (mobileNavLink) {
        closeMobileNavigation();
      }

      /*
      OPEN CONTACT FORM
      */

      var contactButton = event.target.closest(
        '[data-contact]'
      );

      if (contactButton) {
        event.preventDefault();

        openContactModal();

        return;
      }

      /*
      CLOSE CONTACT FORM
      */

      var closeButton = event.target.closest(
        '#modalClose'
      );

      if (closeButton) {
        closeContactModal();

        return;
      }

      /*
      CLOSE MODAL WHEN CLICKING BACKGROUND
      */

      if (
        event.target &&
        event.target.id === 'contactModal'
      ) {
        closeContactModal();
      }
    });

    /*
    ESCAPE KEY CLOSES MODAL
    */

    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Escape') {
          closeContactModal();
        }
      }
    );
  }

  /*
  ============================================================
  INITIALIZE COMET COMPONENTS
  ============================================================
  */

  function initializeComet(root) {
    var scope = root || document;

    initServiceAccordions(scope);
    initMarketTabs(scope);
    initWorkRails(scope);

    /*
    If Shopify contact form was successfully
    submitted, show the confirmation modal.
    */

    if (qs('.comet-form-success', scope)) {
      openContactModal();
    }

    /*
    Reapply selected theme when Shopify reloads
    a section inside the Theme Editor.
    */

    var savedTheme = 'light';

    try {
      savedTheme =
        localStorage.getItem('comet-theme') ||
        'light';
    } catch (error) {}

    applyCometTheme(savedTheme);
  }

  /*
  ============================================================
  INITIAL PAGE LOAD
  ============================================================
  */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        loadSavedTheme();
        initGlobalClickEvents();
        initializeComet(document);
      }
    );
  } else {
    loadSavedTheme();
    initGlobalClickEvents();
    initializeComet(document);
  }

  /*
  ============================================================
  SHOPIFY THEME EDITOR SUPPORT
  ============================================================

  This is important.

  When you add/reorder/edit a section inside
  Shopify's Theme Editor, Shopify can reload
  only that individual section without
  refreshing the entire page.

  This event reinitializes the relevant
  JavaScript automatically.
  ============================================================
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeComet(event.target);
    }
  );

  /*
  Make selected blocks visible in horizontal
  sections when clicking them in Shopify Editor.
  */

  document.addEventListener(
    'shopify:block:select',
    function (event) {
      var block = event.target;

      if (!block) {
        return;
      }

      var workCard = block.closest(
        '.work-card-v10'
      );

      if (workCard) {
        workCard.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  );
})();